import { useEffect } from 'react';

/**
 * GoHighLevel / LeadConnector chat widget loader.
 *
 * IMPORTANT for A2P/TCR compliance: mount this component ONLY on pages that
 * do NOT contain any form collecting phone numbers or SMS opt-in consent.
 * Carriers reject brand registrations that mix a chat widget with lead-capture
 * forms on the same page. See our /privacy and /sms-terms pages, both of
 * which are form-free.
 *
 * Renders no visible DOM itself — the loader script injects its own widget
 * bubble.
 */
const SCRIPT_ID = 'ghl-chat-widget-loader';
const WIDGET_ID = '6a90bf0fd45d62178fa2cea4';

export default function ChatWidget() {
  useEffect(() => {
    // Avoid duplicate script tags if the user navigates between two widget
    // pages during a single SPA session.
    if (document.getElementById(SCRIPT_ID)) return;

    const s = document.createElement('script');
    s.id = SCRIPT_ID;
    s.src = 'https://widgets.leadconnectorhq.com/loader.js';
    s.async = true;
    s.setAttribute(
      'data-resources-url',
      'https://widgets.leadconnectorhq.com/chat-widget/loader.js'
    );
    s.setAttribute('data-widget-id', WIDGET_ID);
    s.setAttribute('data-source', 'WEB_USER');
    document.body.appendChild(s);
  }, []);

  return null;
}
